import { Link } from "react-router-dom";
import { Star } from "lucide-react";

export default function ReviewStrip() {
  return (
    <section data-testid="review-strip" className="border-t border-forest/10 bg-cream">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-6 py-14 text-center md:flex-row md:justify-between md:px-10 md:text-left">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.24em] text-terracotta">Been to the table?</p>
          <p className="mt-2 max-w-2xl font-display text-2xl font-light leading-snug text-forest md:text-3xl">
            How was it? A minute of your time helps us make the next table even better.
          </p>
        </div>
        <Link
          to="/feedback"
          data-testid="review-strip-button"
          className="inline-flex shrink-0 cursor-pointer items-center gap-2 rounded-full bg-terracotta px-7 py-3.5 text-sm font-medium tracking-wide text-cream transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-deepforest"
        >
          <Star size={15} /> Leave a review
        </Link>
      </div>
    </section>
  );
}
